export const APP_MODE = {
    applicationMode : "lite"
    // applicationMode to be decalred 'pro' for full version and 'lite' for lite version
}

